module.exports = __webpack_public_path__ + "static/media/music_djembe_janbe_jambe_woman.355f3dfd.png";